import { Call, Device } from "@twilio/voice-sdk";
import { ClientEvent } from "~/modules/client/Client/ClientEvent";
import { Client } from "~/modules/client/Client/Client";
import { Action } from "~/modules/actions/Action";
import { ClientImpl } from "~/modules/client/Client/ClientImpl/ClientImpl";
import { ContextManager } from "~/modules/contextManager/ContextManager";
import { getLogger } from "~/modules/logger/LoggerFactory/getLogger";
import { LoggerName } from "~/modules/logger/Logger/LoggerName";
import { VoiceController } from "~/modules/voice/VoiceController";
import { VoiceControllerImpl } from "~/modules/voice/VoiceControllerImpl";
import { VoiceCallImpl } from "~/modules/VoiceCall";




export interface AddVoiceEventListenerOptions {
    voiceDevice?: Device;
}






















export class AddVoiceEventListener implements Action<Promise<Client>> {
    
    
    #eventName: ClientEvent;

    #listener: (...args: unknown[]) => void;

    #options?: AddVoiceEventListenerOptions;

    constructor(
        eventName: ClientEvent,
        listener: (...args: unknown[]) => void,
        options?: AddVoiceEventListenerOptions
    ) {
        this.#eventName = eventName;
        this.#listener = listener;
        this.#options = options;
    }

    async #initVoiceController(voiceController: VoiceController, ctx: ContextManager) {
        const logger = getLogger(ctx)(LoggerName.Client);
        if (!voiceController) {
            logger.error("voiceController is undefined in initVoiceController");
            return;
        }
        try {
            if (!voiceController.isInitialized) {
                await voiceController.init(this.#options?.voiceDevice);
            }
        } catch (e) {
            logger.error("Failed to initialise VoiceController", e);
        }
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const client = context.getInstanceOf(ClientImpl);
        const logger = getLogger(context)(LoggerName.Client);

        if (this.#eventName !== ClientEvent.IncomingCall) {
            logger.warn("Attempting to listen to an unknown event:", this.#eventName);
            return client as Client;
        }

        try {
            const voiceController: VoiceController = context.getInstanceOf(VoiceControllerImpl);
            await this.#initVoiceController(voiceController, context);

            if (voiceController?.voiceDevice) {
                voiceController.voiceDevice.on(Device.EventName.Incoming, (call: Call) => {
                    const voiceCall = new VoiceCallImpl(context, call, voiceController.voiceDevice);
                    client.emitter.emit(ClientEvent.IncomingCall, voiceCall);
                });

                const newClient = client.addListener(this.#eventName, this.#listener);
                return newClient as Client;
            }

            logger.error("VoiceController does not have a voiceDevice.");
        } catch (error) {
            logger.error("Failed to add voice event listener to client.", error);
        }

        logger.warn("addVoiceEventListener failed to add a listener to the event:", this.#eventName);
        return client as Client;
    }
}
